import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import { AuthSessionError, AuthSessionResponse } from '@/api/model';

const KEY = {
  GET_SESSION: 'GET_SESSION',
} as const;

const request = {
  getSession: async (signal?: AbortSignal) => {
    const { data } = await fetchClient.FCT.get<AuthSessionResponse>(ENDPOINTS.FCT.AUTH.SESSION, {
      signal,
    });

    return data;
  },
};

const query = {
  useGetSession: (config?: Partial<UseQueryOptions<AuthSessionResponse, AuthSessionError>>) =>
    useQuery<AuthSessionResponse, AuthSessionError>({
      queryFn: ({ signal }) => request.getSession(signal),
      queryKey: [KEY.GET_SESSION],
      // hours * minutes * seconds * milliseconds
      refetchInterval: 2 * 60 * 60 * 1000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: 'always',
      ...config,
    }),
};

export const auth = {
  KEY,
  query,
  request,
};
